import * as React from 'react'

import { cn } from '@/shared/ui/cn'
import { Card, CardContent } from '@/shared/ui/primitives/card'
import { Skeleton } from '@/shared/ui/primitives/skeleton'

type MetricCardProps = {
  label: string
  value: React.ReactNode
  subtitle?: string
  isLoading?: boolean
  variant?: 'card' | 'inline'
  className?: string
  valueClassName?: string
  hideSubtitleOnMobile?: boolean
}

function MetricCard({
  label,
  value,
  subtitle,
  isLoading,
  variant = 'card',
  className,
  valueClassName,
  hideSubtitleOnMobile,
}: MetricCardProps) {
  const content = (
    <>
      <p className="text-xs font-medium uppercase tracking-wider text-muted-foreground">
        {label}
      </p>
      {isLoading ? (
        <Skeleton className="h-8 w-16" />
      ) : (
        <p
          className={cn(
            'truncate font-mono text-2xl font-semibold tabular-nums text-foreground',
            valueClassName,
          )}
        >
          {value}
        </p>
      )}
      {subtitle ? (
        <p
          className={cn(
            'text-xs text-muted-foreground',
            hideSubtitleOnMobile && 'hidden md:block',
          )}
        >
          {subtitle}
        </p>
      ) : null}
    </>
  )

  if (variant === 'inline') {
    return (
      <div
        data-slot="metric-card"
        className={cn('flex min-w-0 flex-col gap-1 rounded-lg border p-3 text-center', className)}
      >
        {content}
      </div>
    )
  }

  return (
    <Card data-slot="metric-card" className={cn('min-w-0 py-4', className)}>
      <CardContent className="flex min-w-0 flex-col gap-1">
        {content}
      </CardContent>
    </Card>
  )
}

export { MetricCard }
export type { MetricCardProps }
